import http, { CancelToken } from '../http-common';

class UploadFilesService {
    cancelar;

    cancelarCarga() {
        this.cancelar();
    }

    generarTokenCancelacion() {
        return new CancelToken((c) => {
            this.cancelar = c;
        });
    }

    // Carga un archivo al servidor destino
    upload = (
        file,
        pathCompleto,
        tempPath,
        tokenCancelar,
        onUploadProgress
    ) => {
        let formData = new FormData();

        formData.append('file', file);
        formData.append('tempPath', tempPath);

        return http.post(pathCompleto, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            cancelToken: tokenCancelar,
            onUploadProgress,
        });
    };

    /**
     * Funcion para subir al servidor un archivo correspondiente a la carga manual de internaciones
     *
     * @param {File} file
     * @param {String} codPrestador
     * @param {String} tempPath
     * @param {Object} internacion
     * @param {event} onUploadProgress
     */
    uploadInternacion(
        file,
        codPrestador,
        tempPath,
        internacion,
        tokenCancelar,
        onUploadProgress
    ) {
        let formData = new FormData();

        formData.append('file', file);
        formData.append('tempPath', tempPath);
        formData.append(
            'internacion',
            new Blob([JSON.stringify(internacion)], {
                type: 'application/json',
            })
        );

        return http.post(
            'presentaciones/internaciones/files/' + codPrestador,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                cancelToken: tokenCancelar,
                onUploadProgress,
            }
        );
    }

    /**
     * Funcion para subir los archivos de carga masiva en internaciones
     *
     * @param {File} file
     * @param {String} tempPath
     * @param {event} onUploadProgress
     */
    uploadInternaciones(file, tempPath, tokenCancelar, onUploadProgress) {
        let formData = new FormData();

        formData.append('file', file);
        formData.append('tempPath', tempPath);

        return http.post('presentaciones/internaciones/files/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            cancelToken: tokenCancelar,
            onUploadProgress,
        });
    }

    // Descarga un archivo del servidor destino
    getFiles(fileName) {
        const path = 'demo';

        return http.get('/files/?path=' + path + '&fileName=' + fileName, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': '*/*',
            },
        });
    }

    createBlob = (fileName, data) => {
        let blob = null;
        if (fileName.includes('.pdf')) {
            blob = new Blob([data], {
                type: 'application/pdf',
            });
        } else if (fileName.includes('.xlsx')) {
            blob = new Blob([data], {
                type:
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
        } else {
            blob = new Blob([data]);
        }

        return blob;
    };

    showFile = (fileName) => {
        return this.getFiles(fileName).then((response) => {
            const blob = this.createBlob(fileName, response.data);

            if (fileName.includes('.xlsx')) {
                return blob;
            }

            const url = URL.createObjectURL(blob);
            return url;
        });
    };

    downloadFile = (fileName) => {
        return this.getFiles(fileName).then((response) => {
            const blob = this.createBlob(fileName, response.data);

            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        });
    };
    // Elimina un archivo del servidor destino
    deleteFile(pathArchivo) {
        return http.delete('presentaciones/file/', {
            params: { pathFile: pathArchivo },
        });
    }

    cancelarCargaMasiva(tempPath) {
        return http.delete('presentaciones/internaciones/files', {
            params: { tempPath: tempPath },
        });
    }

    cancelarPresentacion(tempPath) {
        return http.delete('presentaciones/files', {
            params: { tempPath: tempPath },
        });
    }

    descargarGrlla(filtro) {
        const queryString = require('query-string');

        return http
            .get('/presentaciones/', {
                params: filtro,
                paramsSerializer: (params) => {
                    return queryString.stringify(params);
                },
                responseType: 'blob',
                headers: {
                    'Content-type': 'application/json',
                    Accept:
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/json',
                },
            })
            .then((response) => {
                const url = URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'GrillaPresentaciones.xlsx');
                document.body.appendChild(link);
                link.click();
            });
    }

    descargarTemplate() {
        return http
            .get('/presentaciones/file/prestaciones/template', {
                responseType: 'blob',
                headers: {
                    'Content-type': 'application/json',
                    Accept:
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/json',
                },
            })
            .then((response) => {
                const url = URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'PlanillaPrestaciones.xlsx');
                document.body.appendChild(link);
                link.click();
            });
    }

    descargarAdjunto(pathFile, nombreArchivo) {
        return http
            .get('/presentaciones/file/', {
                params: { pathFile: pathFile },
                responseType: 'blob',
                headers: {
                    'Content-Type': '*/*',
                },
            })
            .then((response) => {
                const url = URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', nombreArchivo);
                document.body.appendChild(link);
                link.click();
            });
    }
}

export default new UploadFilesService();
